import "./sidebar.css";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
// import { useContext } from "react";
// import { AppContext } from "../../Theme";
export default function Sidebar(props) {
	// const { toggleMode } = useContext(AppContext);
	let location = useLocation();
	const [isExpanded, setIsExpanded] = useState(false);
	const [isOpen, setIsOpen] = useState(false);

	const handletogglesettingmenu = () => {
		if (isOpen === false) {
			setIsOpen(true);
		} else {
			setIsOpen(false);
		}
	};
	const handleExpansion = () => {
		if (isExpanded === false) {
			setIsExpanded(true);
		} else {
			setIsExpanded(false);
		}
	};

	return (
		<>
			<div
				className="sidebar"
				style={{
					width: isExpanded ? "220px" : "75px",
					backgroundColor: props.mode ? "rgba(46, 46, 72, 1)" : "white",
				}}>
				<div className="burger-menu" onClick={handleExpansion}>
					<img src="images/burger.svg" alt="" />
				</div>
				<div className="icons">
					<Link to="/">
						<div className="icon1">
							<div
								className={` img-src${
									location.pathname === "/" ? "active" : ""
								} `}>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="25"
									height="25"
									viewBox="0 0 25 25"
									fill="none">
									<path
										d="M22.5156 9.99984C22.5156 9.66832 22.3839 9.35037 22.1495 9.11595C21.9151 8.88152 21.5971 8.74983 21.2656 8.74983C20.9341 8.74983 20.6161 8.88152 20.3817 9.11595C20.1473 9.35037 20.0156 9.66832 20.0156 9.99984H22.5156ZM5.01541 9.99984C5.01541 9.66832 4.88372 9.35037 4.64929 9.11595C4.41487 8.88152 4.09693 8.74983 3.7654 8.74983C3.43388 8.74983 3.11593 8.88152 2.88151 9.11595C2.64709 9.35037 2.51539 9.66832 2.51539 9.99984H5.01541ZM22.8819 13.3836C23.1176 13.6113 23.4334 13.7373 23.7611 13.7345C24.0889 13.7316 24.4024 13.6002 24.6342 13.3684C24.8659 13.1366 24.9974 12.8231 25.0002 12.4954C25.0031 12.1676 24.8771 11.8519 24.6494 11.6161L22.8819 13.3836ZM12.5155 1.24975L13.3993 0.365987C13.1648 0.131646 12.847 0 12.5155 0C12.184 0 11.8661 0.131646 11.6317 0.365987L12.5155 1.24975ZM0.381614 11.6161C0.262225 11.7314 0.166997 11.8693 0.101485 12.0219C0.0359727 12.1744 0.00148948 12.3384 4.71964e-05 12.5044C-0.00139509 12.6703 0.0302324 12.8349 0.0930842 12.9886C0.155936 13.1422 0.248753 13.2818 0.366121 13.3991C0.483488 13.5165 0.623054 13.6093 0.776676 13.6722C0.930298 13.735 1.0949 13.7666 1.26088 13.7652C1.42685 13.7638 1.59088 13.7293 1.74338 13.6638C1.89589 13.5982 2.03382 13.503 2.14913 13.3836L0.381614 11.6161ZM6.26543 25H18.7656V22.5H6.26543V25ZM22.5156 21.25V9.99984H20.0156V21.25H22.5156ZM5.01541 21.25V9.99984H2.51539V21.25H5.01541ZM24.6494 11.6161L13.3993 0.365987L11.6317 2.13351L22.8819 13.3836L24.6494 11.6161ZM11.6317 0.365987L0.381614 11.6161L2.14913 13.3836L13.3993 2.13351L11.6317 0.365987ZM18.7656 25C19.7601 25 20.714 24.6049 21.4172 23.9016C22.1205 23.1984 22.5156 22.2445 22.5156 21.25H20.0156C20.0156 21.5815 19.8839 21.8994 19.6495 22.1339C19.415 22.3683 19.0971 22.5 18.7656 22.5V25ZM6.26543 22.5C5.9339 22.5 5.61596 22.3683 5.38154 22.1339C5.14711 21.8994 5.01541 21.5815 5.01541 21.25H2.51539C2.51539 22.2445 2.91048 23.1984 3.61375 23.9016C4.31702 24.6049 5.27086 25 6.26543 25V22.5Z"
										fill={location.pathname === "/" ? "#4169E1" : "#A7A8AB"}
									/>
								</svg>
							</div>
							<h3
								style={{ display: isExpanded ? "block" : "none" }}
								className="sidebar-heading">
								Dashboard
							</h3>
						</div>
					</Link>
					<Link to="/projectsettings">
						<div className="icon2">
							<div
								className={` img-src${
									location.pathname === "/projectsettings" ? "active" : ""
								} `}>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="25"
									height="25"
									viewBox="0 0 25 25"
									fill="none">
									<path
										d="M5.59211 0C6.32647 0 7.05365 0.144644 7.73211 0.425674C8.41058 0.706703 9.02705 1.11861 9.54632 1.63789C10.0656 2.15716 10.4775 2.77363 10.7585 3.4521C11.0396 4.13056 11.1842 4.85774 11.1842 5.5921V11.1842H5.59211C4.10899 11.1842 2.68662 10.595 1.63789 9.54632C0.589169 8.4976 2.39104e-06 7.07522 2.39104e-06 5.5921C2.39104e-06 4.10899 0.589169 2.68661 1.63789 1.63789C2.68662 0.589167 4.10899 0 5.59211 0ZM8.55263 8.55263V5.5921C8.55263 5.00657 8.379 4.43418 8.05369 3.94732C7.72839 3.46047 7.26602 3.08101 6.72505 2.85694C6.18409 2.63286 5.58882 2.57423 5.01454 2.68846C4.44025 2.8027 3.91274 3.08466 3.4987 3.4987C3.08466 3.91273 2.8027 4.44025 2.68847 5.01453C2.57423 5.58882 2.63286 6.18408 2.85694 6.72505C3.08101 7.26601 3.46047 7.72839 3.94733 8.05369C4.43418 8.379 5.00657 8.55263 5.59211 8.55263H8.55263ZM5.59211 13.8158H11.1842V19.4079C11.1842 20.5139 10.8562 21.5951 10.2418 22.5147C9.6273 23.4343 8.75394 24.1511 7.73211 24.5743C6.71029 24.9976 5.5859 25.1083 4.50114 24.8925C3.41638 24.6768 2.41996 24.1442 1.63789 23.3621C0.855822 22.58 0.323226 21.5836 0.107453 20.4989C-0.108319 19.4141 0.00242297 18.2897 0.425676 17.2679C0.848929 16.2461 1.56568 15.3727 2.4853 14.7582C3.40492 14.1438 4.48609 13.8158 5.59211 13.8158ZM5.59211 16.4474C5.00657 16.4474 4.43418 16.621 3.94733 16.9463C3.46047 17.2716 3.08101 17.734 2.85694 18.2749C2.63286 18.8159 2.57423 19.4112 2.68847 19.9855C2.8027 20.5597 3.08466 21.0873 3.4987 21.5013C3.91274 21.9153 4.44025 22.1973 5.01454 22.3115C5.58882 22.4258 6.18409 22.3671 6.72505 22.1431C7.26602 21.919 7.72839 21.5395 8.05369 21.0527C8.379 20.5658 8.55263 19.9934 8.55263 19.4079V16.4474H5.59211ZM19.4079 0C20.891 0 22.3134 0.589167 23.3621 1.63789C24.4108 2.68661 25 4.10899 25 5.5921C25 7.07522 24.4108 8.4976 23.3621 9.54632C22.3134 10.595 20.891 11.1842 19.4079 11.1842H13.8158V5.5921C13.8158 4.10899 14.405 2.68661 15.4537 1.63789C16.5024 0.589167 17.9248 0 19.4079 0ZM19.4079 8.55263C19.9934 8.55263 20.5658 8.379 21.0527 8.05369C21.5395 7.72839 21.919 7.26601 22.1431 6.72505C22.3671 6.18408 22.4258 5.58882 22.3115 5.01453C22.1973 4.44025 21.9153 3.91273 21.5013 3.4987C21.0873 3.08466 20.5598 2.8027 19.9855 2.68846C19.4112 2.57423 18.8159 2.63286 18.275 2.85694C17.734 3.08101 17.2716 3.46047 16.9463 3.94732C16.621 4.43418 16.4474 5.00657 16.4474 5.5921V8.55263H19.4079ZM13.8158 13.8158H19.4079C20.5139 13.8158 21.5951 14.1438 22.5147 14.7582C23.4343 15.3727 24.1511 16.2461 24.5743 17.2679C24.9976 18.2897 25.1083 19.4141 24.8925 20.4989C24.6768 21.5836 24.1442 22.58 23.3621 23.3621C22.58 24.1442 21.5836 24.6768 20.4989 24.8925C19.4141 25.1083 18.2897 24.9976 17.2679 24.5743C16.2461 24.1511 15.3727 23.4343 14.7582 22.5147C14.1438 21.5951 13.8158 20.5139 13.8158 19.4079V13.8158ZM16.4474 16.4474V19.4079C16.4474 19.9934 16.621 20.5658 16.9463 21.0527C17.2716 21.5395 17.734 21.919 18.275 22.1431C18.8159 22.3671 19.4112 22.4258 19.9855 22.3115C20.5598 22.1973 21.0873 21.9153 21.5013 21.5013C21.9153 21.0873 22.1973 20.5597 22.3115 19.9855C22.4258 19.4112 22.3671 18.8159 22.1431 18.2749C21.919 17.734 21.5395 17.2716 21.0527 16.9463C20.5658 16.621 19.9934 16.4474 19.4079 16.4474H16.4474Z"
										fill={
											location.pathname === "/projectsettings"
												? "#4169E1"
												: "#A7A8AB"
										}
									/>
								</svg>
							</div>
							<h3
								style={{
									display: isExpanded ? "block" : "none",
								}}
								className="sidebar-heading">
								App/Projects
							</h3>
						</div>
					</Link>
					<Link to="/logs">
						<div className="icon3">
							<div
								className={` img-src1${
									location.pathname === "/logs" ? "active" : ""
								} `}>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="28"
									height="32"
									viewBox="0 0 28 32"
									fill="none">
									<path
										d="M5.5 5.49979H26.5V30.9998H5.5V5.49979Z"
										stroke={
											location.pathname === "/logs" ? "#4169E1" : "#A7A8AB"
										}
										strokeWidth="2"
										strokeLinejoin="round"
									/>
									<path
										d="M22 5.5V1H1.75C1.55109 1 1.36032 1.07902 1.21967 1.21967C1.07902 1.36032 1 1.55109 1 1.75V26.5H5.5M11.5 14.5H20.5M11.5 20.5H20.5"
										stroke={
											location.pathname === "/logs" ? "#4169E1" : "#A7A8AB"
										}
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							</div>
							<h3
								className="sidebar-heading"
								style={{ display: isExpanded ? "block" : "none" }}>
								Logs
							</h3>
						</div>
					</Link>
					<Link to="/textsms">
						<div className="icon4">
							<div
								className={` img-src${
									location.pathname === "/textsms" ? "active" : ""
								} `}>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="22"
									height="22"
									viewBox="0 0 22 22"
									fill="none">
									<path
										d="M6.6 9.9C6.91167 9.9 7.1731 9.7944 7.3843 9.5832C7.5955 9.372 7.70073 9.11093 7.7 8.8C7.7 8.48833 7.5944 8.2269 7.3832 8.0157C7.172 7.8045 6.91093 7.69927 6.6 7.7C6.28833 7.7 6.0269 7.8056 5.8157 8.0168C5.6045 8.228 5.49927 8.48907 5.5 8.8C5.5 9.11167 5.6056 9.3731 5.8168 9.5843C6.028 9.7955 6.28907 9.90073 6.6 9.9ZM11 9.9C11.3117 9.9 11.5731 9.7944 11.7843 9.5832C11.9955 9.372 12.1007 9.11093 12.1 8.8C12.1 8.48833 11.9944 8.2269 11.7832 8.0157C11.572 7.8045 11.3109 7.69927 11 7.7C10.6883 7.7 10.4269 7.8056 10.2157 8.0168C10.0045 8.228 9.89927 8.48907 9.9 8.8C9.9 9.11167 10.0056 9.3731 10.2168 9.5843C10.428 9.7955 10.6891 9.90073 11 9.9ZM15.4 9.9C15.7117 9.9 15.9731 9.7944 16.1843 9.5832C16.3955 9.372 16.5007 9.11093 16.5 8.8C16.5 8.48833 16.3944 8.2269 16.1832 8.0157C15.972 7.8045 15.7109 7.69927 15.4 7.7C15.0883 7.7 14.8269 7.8056 14.6157 8.0168C14.4045 8.228 14.2993 8.48907 14.3 8.8C14.3 9.11167 14.4056 9.3731 14.6168 9.5843C14.828 9.7955 15.0891 9.90073 15.4 9.9ZM0 22V2.2C0 1.595 0.2156 1.0769 0.6468 0.645702C1.078 0.214502 1.59573 -0.000731466 2.2 1.86757e-06H19.8C20.405 1.86757e-06 20.9231 0.215602 21.3543 0.646802C21.7855 1.078 22.0007 1.59574 22 2.2V15.4C22 16.005 21.7844 16.5231 21.3532 16.9543C20.922 17.3855 20.4043 17.6007 19.8 17.6H4.4L0 22ZM3.465 15.4H19.8V2.2H2.2V16.6375L3.465 15.4Z"
										fill={
											location.pathname === "/textsms" ? "#4169E1" : "#A7A8AB"
										}
									/>
								</svg>
							</div>
							<h3
								className="sidebar-heading"
								style={{ display: isExpanded ? "block" : "none" }}>
								Text SMS
							</h3>
						</div>
					</Link>
					<Link to="/billing">
						<div className="icon5">
							<div
								className={` img-src1${
									location.pathname === "/billing" ? "active" : ""
								} `}>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="27"
									height="27"
									viewBox="0 0 27 27"
									fill="none">
									<path
										d="M13.5 8.69228V5.80766M13.5 8.69228C11.9038 8.69228 10.6154 8.69228 10.6154 10.6154C10.6154 13.5 16.3846 13.5 16.3846 16.3846C16.3846 18.3077 15.0961 18.3077 13.5 18.3077M13.5 8.69228C15.0961 8.69228 16.3846 9.42305 16.3846 10.6154M10.6154 16.3846C10.6154 17.8269 11.9038 18.3077 13.5 18.3077M13.5 18.3077V21.1923"
										stroke={
											location.pathname === "/billing" ? "#4169E1" : "#A7A8AB"
										}
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
									<path
										d="M13.5 26C20.4036 26 26 20.4036 26 13.5C26 6.59644 20.4036 1 13.5 1C6.59644 1 1 6.59644 1 13.5C1 20.4036 6.59644 26 13.5 26Z"
										stroke={
											location.pathname === "/billing" ? "#4169E1" : "#A7A8AB"
										}
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							</div>
							<h3
								className="sidebar-heading"
								style={{ display: isExpanded ? "block" : "none" }}>
								Billing
							</h3>
						</div>
					</Link>
					<Link to="/subscriptions">
						<div className="icon6">
							<div
								className={` img-src${
									(location.pathname === "/subscriptions") |
									(location.pathname === "/custompackage") |
									(location.pathname === "/payasyougo")
										? "active"
										: ""
								} `}>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="25"
									height="25"
									viewBox="0 0 25 25"
									fill="none">
									<path
										d="M24.7887 16.4484C24.7973 16.4656 24.8016 16.5902 24.8016 16.8223C24.8016 17.0543 24.8059 17.3508 24.8145 17.7117C24.823 18.0727 24.823 18.4895 24.8145 18.9621C24.8059 19.4348 24.8059 19.9117 24.8145 20.393C24.823 20.8742 24.8188 21.3641 24.8016 21.8625C24.7844 22.3609 24.7844 22.7992 24.8016 23.1773C24.8188 23.5555 24.8145 23.8949 24.7887 24.1957C24.7629 24.4965 24.7629 24.6812 24.7887 24.75H0.0386719V23.1902C0.0386719 22.7863 0.034375 22.3437 0.0257813 21.8625C0.0171875 21.3812 0.0171875 20.8957 0.0257813 20.4059C0.034375 19.916 0.0300781 19.4348 0.0128906 18.9621C-0.00429688 18.4895 -0.00429688 18.077 0.0128906 17.7246C0.0300781 17.3723 0.0300781 17.0715 0.0128906 16.8223C-0.00429688 16.573 0.00429687 16.4484 0.0386719 16.4484L4.97578 1.65H9.93867V3.3H6.16172L1.76602 16.5H7.1543L8.8043 19.8H16.023L17.673 16.5H23.0613L18.6656 3.3H14.8887V1.65H19.8516L24.7887 16.4484ZM23.1387 18.15H18.7043L17.0543 21.45H7.77305L6.12305 18.15H1.68867V23.1H23.1387V18.15ZM11.5887 12.027V0H13.2387V12.027L17.0285 8.25L18.1887 9.41016L12.4137 15.1852L6.63867 9.41016L7.79883 8.25L11.5887 12.027Z"
										fill={
											(location.pathname === "/subscriptions") |
											(location.pathname === "/custompackage") |
											(location.pathname === "/payasyougo")
												? "#4169E1"
												: "#A7A8AB"
										}
									/>
								</svg>
							</div>
							<h3
								className="sidebar-heading"
								style={{ display: isExpanded ? "block" : "none" }}>
								Subscriptions
							</h3>
						</div>
					</Link>
					<Link to="/team">
						<div className="icon7">
							<div
								className={`img-src${
									location.pathname === "/team" ? "active" : ""
								} `}>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="25"
									height="25"
									viewBox="0 0 25 25"
									fill="none">
									<path
										d="M12.5 11.25C14.1576 11.25 15.7473 11.9085 16.9194 13.0806C18.0915 14.2527 18.75 15.8424 18.75 17.5V25H16.25V17.5C16.2501 16.5435 15.8846 15.6231 15.2284 14.9272C14.5722 14.2312 13.6749 13.8124 12.72 13.7563L12.5 13.75C11.5435 13.7499 10.6231 14.1154 9.92717 14.7716C9.23124 15.4278 8.81237 16.3251 8.75625 17.28L8.75 17.5V25H6.25V17.5C6.25 15.8424 6.90848 14.2527 8.08058 13.0806C9.25269 11.9085 10.8424 11.25 12.5 11.25ZM4.375 15C4.72375 15 5.0625 15.0412 5.3875 15.1175C5.17379 15.7538 5.04723 16.416 5.01125 17.0862L5 17.5V17.6075C4.85631 17.5561 4.70686 17.5225 4.555 17.5075L4.375 17.5C3.90909 17.5 3.45987 17.6734 3.11487 17.9866C2.76986 18.2997 2.55379 18.73 2.50875 19.1937L2.5 19.375V25H0V19.375C0 18.2147 0.460936 17.1019 1.28141 16.2814C2.10188 15.4609 3.21468 15 4.375 15ZM20.625 15C21.7853 15 22.8981 15.4609 23.7186 16.2814C24.5391 17.1019 25 18.2147 25 19.375V25H22.5V19.375C22.5 18.9091 22.3266 18.4599 22.0134 18.1149C21.7003 17.7699 21.27 17.5538 20.8063 17.5087L20.625 17.5C20.4063 17.5 20.1963 17.5375 20 17.6062V17.5C20 16.6675 19.865 15.8675 19.615 15.12C19.9375 15.0412 20.2775 15 20.625 15ZM4.375 7.5C5.2038 7.5 5.99866 7.82924 6.58471 8.41529C7.17076 9.00134 7.5 9.7962 7.5 10.625C7.5 11.4538 7.17076 12.2487 6.58471 12.8347C5.99866 13.4208 5.2038 13.75 4.375 13.75C3.5462 13.75 2.75134 13.4208 2.16529 12.8347C1.57924 12.2487 1.25 11.4538 1.25 10.625C1.25 9.7962 1.57924 9.00134 2.16529 8.41529C2.75134 7.82924 3.5462 7.5 4.375 7.5ZM20.625 7.5C21.4538 7.5 22.2487 7.82924 22.8347 8.41529C23.4208 9.00134 23.75 9.7962 23.75 10.625C23.75 11.4538 23.4208 12.2487 22.8347 12.8347C22.2487 13.4208 21.4538 13.75 20.625 13.75C19.7962 13.75 19.0013 13.4208 18.4153 12.8347C17.8292 12.2487 17.5 11.4538 17.5 10.625C17.5 9.7962 17.8292 9.00134 18.4153 8.41529C19.0013 7.82924 19.7962 7.5 20.625 7.5ZM4.375 10C4.20924 10 4.05027 10.0658 3.93306 10.1831C3.81585 10.3003 3.75 10.4592 3.75 10.625C3.75 10.7908 3.81585 10.9497 3.93306 11.0669C4.05027 11.1842 4.20924 11.25 4.375 11.25C4.54076 11.25 4.69973 11.1842 4.81694 11.0669C4.93415 10.9497 5 10.7908 5 10.625C5 10.4592 4.93415 10.3003 4.81694 10.1831C4.69973 10.0658 4.54076 10 4.375 10ZM20.625 10C20.4592 10 20.3003 10.0658 20.1831 10.1831C20.0658 10.3003 20 10.4592 20 10.625C20 10.7908 20.0658 10.9497 20.1831 11.0669C20.3003 11.1842 20.4592 11.25 20.625 11.25C20.7908 11.25 20.9497 11.1842 21.0669 11.0669C21.1842 10.9497 21.25 10.7908 21.25 10.625C21.25 10.4592 21.1842 10.3003 21.0669 10.1831C20.9497 10.0658 20.7908 10 20.625 10ZM12.5 0C13.8261 0 15.0979 0.526784 16.0355 1.46447C16.9732 2.40215 17.5 3.67392 17.5 5C17.5 6.32608 16.9732 7.59785 16.0355 8.53553C15.0979 9.47322 13.8261 10 12.5 10C11.1739 10 9.90215 9.47322 8.96447 8.53553C8.02678 7.59785 7.5 6.32608 7.5 5C7.5 3.67392 8.02678 2.40215 8.96447 1.46447C9.90215 0.526784 11.1739 0 12.5 0ZM12.5 2.5C11.837 2.5 11.2011 2.76339 10.7322 3.23223C10.2634 3.70107 10 4.33696 10 5C10 5.66304 10.2634 6.29893 10.7322 6.76777C11.2011 7.23661 11.837 7.5 12.5 7.5C13.163 7.5 13.7989 7.23661 14.2678 6.76777C14.7366 6.29893 15 5.66304 15 5C15 4.33696 14.7366 3.70107 14.2678 3.23223C13.7989 2.76339 13.163 2.5 12.5 2.5Z"
										fill={location.pathname === "/team" ? "#4169E1" : "#A7A8AB"}
									/>
								</svg>
							</div>
							<h3
								className="sidebar-heading"
								style={{ display: isExpanded ? "block" : "none" }}>
								Team
							</h3>
						</div>
					</Link>
				</div>
				`
				<div className="setting-menu" onClick={handletogglesettingmenu}>
					<div className="img-src1">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="28"
							height="28"
							viewBox="0 0 28 28"
							fill="none">
							<g clipPath="url(#clip0_188_140)">
								<path
									d="M14 17.5C15.933 17.5 17.5 15.933 17.5 14C17.5 12.067 15.933 10.5 14 10.5C12.067 10.5 10.5 12.067 10.5 14C10.5 15.933 12.067 17.5 14 17.5Z"
									stroke="#A7A8AB"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
								<path
									d="M22.6334 17.5C22.4781 17.8519 22.4317 18.2422 22.5003 18.6207C22.569 18.9991 22.7494 19.3484 23.0184 19.6233L23.0884 19.6933C23.3053 19.91 23.4774 20.1674 23.5948 20.4506C23.7123 20.7339 23.7727 21.0375 23.7727 21.3442C23.7727 21.6508 23.7123 21.9544 23.5948 22.2377C23.4774 22.5209 23.3053 22.7783 23.0884 22.995C22.8717 23.2119 22.6143 23.384 22.331 23.5015C22.0478 23.6189 21.7442 23.6793 21.4375 23.6793C21.1309 23.6793 20.8273 23.6189 20.544 23.5015C20.2607 23.384 20.0034 23.2119 19.7867 22.995L19.7167 22.925C19.4417 22.656 19.0925 22.4756 18.714 22.407C18.3356 22.3384 17.9452 22.3847 17.5934 22.54C17.2483 22.6879 16.954 22.9334 16.7467 23.2464C16.5394 23.5595 16.4282 23.9262 16.4267 24.3017V24.5C16.4267 25.1188 16.1809 25.7123 15.7433 26.1499C15.3057 26.5875 14.7122 26.8333 14.0934 26.8333C13.4745 26.8333 12.881 26.5875 12.4434 26.1499C12.0059 25.7123 11.76 25.1188 11.76 24.5V24.395C11.751 24.0088 11.626 23.6343 11.4013 23.3201C11.1766 23.006 10.8625 22.7667 10.5 22.6333C10.1481 22.478 9.7578 22.4317 9.37933 22.5003C9.00087 22.5689 8.65165 22.7494 8.37669 23.0183L8.30669 23.0883C8.08998 23.3053 7.83264 23.4774 7.54938 23.5948C7.26612 23.7122 6.96249 23.7727 6.65585 23.7727C6.34922 23.7727 6.04559 23.7122 5.76233 23.5948C5.47906 23.4774 5.22172 23.3053 5.00502 23.0883C4.78808 22.8716 4.61597 22.6143 4.49855 22.331C4.38112 22.0478 4.32068 21.7441 4.32068 21.4375C4.32068 21.1309 4.38112 20.8272 4.49855 20.544C4.61597 20.2607 4.78808 20.0034 5.00502 19.7867L5.07502 19.7167C5.34398 19.4417 5.5244 19.0925 5.59303 18.714C5.66165 18.3355 5.61532 17.9452 5.46002 17.5933C5.31213 17.2483 5.06657 16.954 4.75356 16.7467C4.44056 16.5394 4.07377 16.4282 3.69835 16.4267H3.50002C2.88118 16.4267 2.28769 16.1808 1.8501 15.7432C1.41252 15.3057 1.16669 14.7122 1.16669 14.0933C1.16669 13.4745 1.41252 12.881 1.8501 12.4434C2.28769 12.0058 2.88118 11.76 3.50002 11.76H3.60502C3.99118 11.751 4.36569 11.626 4.67987 11.4013C4.99405 11.1765 5.23336 10.8625 5.36669 10.5C5.52199 10.1481 5.56831 9.75776 5.49969 9.3793C5.43107 9.00084 5.25065 8.65162 4.98169 8.37666L4.91169 8.30666C4.69474 8.08995 4.52264 7.83261 4.40521 7.54935C4.28779 7.26609 4.22735 6.96246 4.22735 6.65582C4.22735 6.34919 4.28779 6.04556 4.40521 5.7623C4.52264 5.47903 4.69474 5.22169 4.91169 5.00499C5.12839 4.78804 5.38573 4.61594 5.66899 4.49852C5.95226 4.38109 6.25588 4.32065 6.56252 4.32065C6.86916 4.32065 7.17279 4.38109 7.45605 4.49852C7.73931 4.61594 7.99665 4.78804 8.21335 5.00499L8.28335 5.07499C8.55831 5.34395 8.90754 5.52437 9.286 5.593C9.66446 5.66162 10.0548 5.61529 10.4067 5.45999H10.5C10.8451 5.3121 11.1394 5.06654 11.3467 4.75353C11.554 4.44053 11.6652 4.07374 11.6667 3.69832V3.49999C11.6667 2.88115 11.9125 2.28766 12.3501 1.85007C12.7877 1.41249 13.3812 1.16666 14 1.16666C14.6189 1.16666 15.2124 1.41249 15.6499 1.85007C16.0875 2.28766 16.3334 2.88115 16.3334 3.49999V3.60499C16.3349 3.98041 16.4461 4.34719 16.6534 4.6602C16.8607 4.97321 17.155 5.21877 17.5 5.36666C17.8519 5.52196 18.2422 5.56828 18.6207 5.49966C18.9992 5.43104 19.3484 5.25062 19.6234 4.98166L19.6934 4.91166C19.9101 4.69471 20.1674 4.52261 20.4507 4.40518C20.7339 4.28776 21.0376 4.22732 21.3442 4.22732C21.6508 4.22732 21.9545 4.28776 22.2377 4.40518C22.521 4.52261 22.7783 4.69471 22.995 4.91166C23.212 5.12836 23.3841 5.3857 23.5015 5.66896C23.6189 5.95222 23.6794 6.25585 23.6794 6.56249C23.6794 6.86913 23.6189 7.17276 23.5015 7.45602C23.3841 7.73928 23.212 7.99662 22.995 8.21332L22.925 8.28332C22.6561 8.55828 22.4756 8.90751 22.407 9.28597C22.3384 9.66443 22.3847 10.0548 22.54 10.4067V10.5C22.6879 10.8451 22.9335 11.1393 23.2465 11.3466C23.5595 11.5539 23.9263 11.6652 24.3017 11.6667H24.5C25.1189 11.6667 25.7124 11.9125 26.1499 12.3501C26.5875 12.7877 26.8334 13.3812 26.8334 14C26.8334 14.6188 26.5875 15.2123 26.1499 15.6499C25.7124 16.0875 25.1189 16.3333 24.5 16.3333H24.395C24.0196 16.3348 23.6528 16.4461 23.3398 16.6533C23.0268 16.8606 22.7812 17.1549 22.6334 17.5V17.5Z"
									stroke="#A7A8AB"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
							</g>
							<defs>
								<clipPath id="clip0_188_140">
									<rect width="28" height="28" fill="white" />
								</clipPath>
							</defs>
						</svg>
					</div>
				</div>
				<div
					className="setting-opt"
					onClose={() => {
						setIsOpen(false);
					}}
					style={{
						display: isOpen ? "flex" : "none",
						backgroundColor: props.mode ? "#383854" : "white",

						color: "#adadc9",
						boxShadow: props.mode
							? "3px -2px 4px 0px rgba(0, 0, 0, 0.25)"
							: "-2px 5px 5px 10px rgba(207, 200, 200, 0.514)",
					}}>
					<div className="toggleswitch">
						<div className="form-check form-switch">
							<input
								className="form-check-input"
								type="checkbox"
								id="flexSwitchCheckChecked"
								onChange={props.toggleMode}
								checked={props.mode}
							/>
							<label
								className="form-check-label"
								htmlFor="flexSwitchCheckChecked">
								Dark Mode
							</label>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
